import styled from '@emotion/styled'

import { Color } from '../../enums/color'
import { getDefaultTransition } from '../../utils/getDefaultTransition'
import { skeletonAnimation } from '../../utils/skeletonAnimation'

interface ProgressBarWrapperProps {
  backgroundColor: Color
  height: number
  withAnimation?: boolean
}

export const ProgressBarWrapper = styled.div<ProgressBarWrapperProps>`
  width: 100%;
  height: ${({ height }) => height}px;
  border-radius: ${({ height }) => height / 2}px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  overflow: hidden;
  ${({ withAnimation }) => withAnimation && skeletonAnimation()};
`

interface ProgressBarProps {
  progress: number
  progressColor: Color
}

export const Progress = styled.div<ProgressBarProps>`
  width: ${({ progress }) => `${progress}%`};
  height: 100%;
  position: relative;
  z-index: 1;
  background-color: ${({ progressColor }) => progressColor};
  ${getDefaultTransition('background-color', 'width')};
`
